"use client";

import { decodeAudioFile } from "mediatools";
import { baseName } from "../_components/format";
import type { MediaOperation } from "./types";

export const extractAudioOperation: MediaOperation<Record<string, never>> = {
  id: "extract-audio",
  group: "audio",
  inputKinds: ["video"],
  outputKind: "audio",
  autoRun: true,
  defaultOptions: {},
  run: async (ctx) => {
    if (!ctx.file) throw new Error("No file selected.");
    const pcm = await decodeAudioFile(ctx.file);
    return { pcm, baseName: `${baseName(ctx.file.name)}-audio` };
  },
};
